<script lang="ts">
	import { onMount } from 'svelte';
	import { isMobileDevice } from '$lib/utils/motion';

	let progress = $state(0);
	let ticking = false;

	onMount(() => {
		// Skip on mobile for performance
		if (isMobileDevice()) return;

		const updateProgress = () => {
			const docHeight = document.documentElement.scrollHeight - window.innerHeight;
			progress = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
			ticking = false;
		};

		const handleScroll = () => {
			if (!ticking) {
				requestAnimationFrame(updateProgress);
				ticking = true;
			}
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => window.removeEventListener('scroll', handleScroll);
	});
</script>

{#if progress > 0}
	<div
		class="hidden md:block fixed top-0 left-0 z-[60] h-[3px] bg-gradient-to-r from-ameta-green to-ameta-accent transition-[width] duration-100 ease-out"
		style="width: {progress}%"
		role="progressbar"
		aria-valuenow={Math.round(progress)}
		aria-valuemin={0}
		aria-valuemax={100}
		aria-label="Page scroll progress"
	></div>
{/if}
